


















































































































































































































































































































































































































































































































































































import { format, parse } from "date-fns";
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { isItaly, getDatePickerOptions } from "../../../services/Helpers";
import { PriceListService } from "../../../services/PriceListService";
import moment from "moment";
import { MBEShipServiceBusiness } from "@/model/enumeration.model";
import { ShipmentService } from "@/services/ShipmentService";
import { getStoreId } from "@/services/AuthService";

@Component({
  components: {}
})
export default class PickupContent extends Vue {
  @Prop({})
  shipment: any;
  @Prop({})
  couriers: any[];
  @Prop({ default: false })
  disabled: boolean;
  @Prop({ default: false })
  showSender: boolean;
  @Prop({})
  pickup: any;
  @Prop({}) timeOverl: number;
  @Prop({ default: "0" }) isFromShipMng: string;

  courierNexiveId: any = 0;
  courierGLSId: any = 0;
  courierTntId: any = 0;
  courierSDAId: any = 0;
  pickupPreferredRangeTime: any = [new Date(), new Date()];
  pickupAlternativeRangeTime: any = [new Date(), new Date()];
  preferredTimeNexive: any = "morning";
  pickupDate: any = new Date();

  pickupDateChange(event: any) {
    this.pickupDate
      ? (this.pickup.pickupDate = moment(this.pickupDate).format("yyyy-MM-DD"))
      : (this.pickup.pickupDate = null);
    this.shipment.pickupDate = moment(this.pickupDate).format("yyyy-MM-DD");
    this.$emit("recalculatePrice");
  }

  pickupPreferredRangeTimeChange(event: any) {
    if (this.pickupPreferredRangeTime) {
      this.pickup.preferredFrom = format(
        this.pickupPreferredRangeTime[0],
        "HH:mm"
      );
      this.pickup.preferredTo = format(
        this.pickupPreferredRangeTime[1],
        "HH:mm"
      );
    } else {
      this.pickup.preferredFrom = null;
      this.pickup.preferredTo = null;
    }
  }

  pickupAlternativeRangeTimeChange(event?: any) {
    if (this.pickupAlternativeRangeTime) {
      this.pickup.alternativeFrom = format(
        this.pickupAlternativeRangeTime[0],
        "HH:mm"
      );
      this.pickup.alternativeTo = format(
        this.pickupAlternativeRangeTime[1],
        "HH:mm"
      );
    } else {
      this.pickup.alternativeFrom = null;
      this.pickup.alternativeTo = null;
    }
  }

  @Watch("pickup.preferredTo")
  @Watch("pickup.alternativeTo")
  @Watch("pickup.alternativeFrom")
  @Watch("pickup.preferredFrom")
  checkOverlap() {
    if (
      (this.pickup.alternativeFrom == null ||
        this.pickup.alternativeTo == "") &&
      this.pickupAlternativeRangeTime &&
      this.pickupAlternativeRangeTime[0] &&
      this.pickupAlternativeRangeTime[1]
    ) {
      this.pickupAlternativeRangeTimeChange();
    }
    if (
      this.pickup.preferredTo !== null &&
      this.pickup.alternativeFrom !== null
    ) {
      const date1begin = this.pickup.preferredFrom.slice(0, 2);
      const date1end = this.pickup.preferredTo.slice(0, 2);
      const date2begin = this.pickup.alternativeFrom.slice(0, 2);
      const date2end = this.pickup.alternativeTo.slice(0, 2);
      const overlap =
        (date1begin > date2begin && date1begin < date2end) ||
        (date2begin > date1begin && date2begin < date1end)
          ? 2
          : 1;
      this.$emit("timeOverlap", overlap);
    } else {
      this.$emit("timeOverlap", 1);
    }
  }

  preferredTimeNexiveChange(event: any) {
    if (this.shipment.courierId == this.courierNexiveId) {
      if (this.preferredTimeNexive === "morning") {
        this.pickup.preferredFrom = "09:00";
        this.pickup.preferredTo = "13:00";
      } else {
        this.pickup.preferredFrom = "14:00";
        this.pickup.preferredTo = "17:00";
      }
    } else if (this.shipment.courierId == this.courierGLSId) {
      if (this.preferredTimeNexive === "morning") {
        this.pickup.preferredFrom = "09:00";
        this.pickup.preferredTo = "13:00";
      } else {
        this.pickup.preferredFrom = "14:00";
        this.pickup.preferredTo = "19:00";
      }
    }
  }

  created() {
    this.courierTntId = 0;
    this.courierSDAId = 0;
    this.courierNexiveId = 0;
    this.courierGLSId = 0;
    this.pickupPreferredRangeTime = [new Date(), new Date()];
    this.pickupAlternativeRangeTime = [new Date(), new Date()];
    this.preferredTimeNexive = "morning";
    this.pickupDate = new Date();
    this.shipment.pickupDate = moment(this.pickupDate).format("yyyy-MM-DD");
  }
  mounted() {
    if (!this.pickup.pickupDate) {
      ShipmentService.prototype
        .getCutoffPickup(
          getStoreId(),
          this.$store.getters["customer/info"].customerId
        )
        .then((res: any) => {
          this.pickup.pickupDate = res.pickupDate;
          this.pickup.alternativeFrom = res.alternativeFrom;
          this.pickup.alternativeTo = res.alternativeTo;
          this.pickup.preferredFrom = res.preferredFrom;
          this.pickup.preferredTo = res.preferredTo;
          this.afterPickupCutoff();
        })
        .catch(e => {
          this.afterPickupCutoff();
        });
    } else {
      this.afterPickupCutoff();
    }
  }

  afterPickupCutoff() {
    // init pickup date + preferredFrom / To and alternative from / to
    if (this.pickup.preferredFrom) {
      const df = new Date();
      const dt = new Date();
      df.setHours(
        parseInt(this.pickup.preferredFrom.split(":")[0]),
        parseInt(this.pickup.preferredFrom.split(":")[1])
      );
      dt.setHours(
        parseInt(this.pickup.preferredTo.split(":")[0]),
        parseInt(this.pickup.preferredTo.split(":")[1])
      );
      this.pickupPreferredRangeTime = [df, dt];
    } else {
      const timeFrom = new Date();
      const timeTo = new Date();

      timeFrom.setHours(9, 0);
      timeTo.setHours(18, 0);

      this.pickupPreferredRangeTime = [timeFrom, timeTo];
    }

    if (this.pickup.alternativeFrom) {
      const df = new Date();
      const dt = new Date();
      df.setHours(
        parseInt(this.pickup.alternativeFrom.split(":")[0]),
        parseInt(this.pickup.alternativeFrom.split(":")[1])
      );
      dt.setHours(
        parseInt(this.pickup.alternativeTo.split(":")[0]),
        parseInt(this.pickup.alternativeTo.split(":")[1])
      );
      this.pickupAlternativeRangeTime = [df, dt];
    } else {
      const timeFrom = new Date();
      const timeTo = new Date();

      timeFrom.setHours(9, 0);
      timeTo.setHours(18, 0);

      this.pickupAlternativeRangeTime = [timeFrom, timeTo];
    }

    if (this.pickup.pickupDate) {
      this.pickupDate = parse(this.pickup.pickupDate, "yyyy-MM-dd", new Date());
    }

    if (!this.couriers || this.couriers.length === 0) {
      // fetch couriers list if we're not passing it, like in edit shipment
      PriceListService.getCouriers()
        .then((res: any) => {
          this.findCourierIds(res.data);
        })
        .catch((err: any) => {
          this.$notify.error(err.message);
        });
    } else {
      this.findCourierIds(this.couriers);
    }
    this.pickupPreferredRangeTimeChange(0);
  }

  // fetch courierIds for Nexive and TNT
  findCourierIds(couriers: any[]) {
    this.courierNexiveId = 7;
    this.courierGLSId = 8;
    this.courierTntId = 3;
    this.courierSDAId = 5;

    // if we are using courier Nexive or GLS preselect on init morning range.
    // if editing a new pickup init ranges
    if (
      !this.shipment.id &&
      (this.shipment.courierId === this.courierNexiveId ||
        this.shipment.courierId === this.courierGLSId)
    ) {
      this.preferredTimeNexiveChange(undefined);
    }

    // if we're editing a new pickup and we're using TNT|SDA init alternative time to 09:00-18:00
    if (
      !this.shipment.id &&
      (this.shipment.courierId === this.courierTntId ||
        this.shipment.courierId === this.courierSDAId) &&
      !this.pickup.alternativeFrom &&
      this.$store.getters.customer.config.pickupData
    ) {
      this.pickup.alternativeFrom = this.$store.getters.customer.config.pickupData.alternativeFrom;
      this.pickup.alternativeTo = this.$store.getters.customer.config.pickupData.alternativeTo;
      const df = new Date();
      const dt = new Date();
      if (this.pickup.alternativeFrom && this.pickup.alternativeTo) {
        df.setHours(
          parseInt(this.pickup.alternativeFrom.split(":")[0]),
          parseInt(this.pickup.alternativeFrom.split(":")[1])
        );
        dt.setHours(
          parseInt(this.pickup.alternativeTo.split(":")[0]),
          parseInt(this.pickup.alternativeTo.split(":")[1])
        );
      }
      this.pickupAlternativeRangeTime = [df, dt];

      this.pickup.preferredFrom = this.$store.getters.customer.config.pickupData.preferredFrom;
      this.pickup.preferredTo = this.$store.getters.customer.config.pickupData.preferredTo;
      const dff = new Date();
      const dtt = new Date();
      if (this.pickup.preferredFrom && this.pickup.preferredTo) {
        dff.setHours(
          parseInt(this.pickup.preferredFrom.split(":")[0]),
          parseInt(this.pickup.preferredTo.split(":")[1])
        );
        dtt.setHours(
          parseInt(this.pickup.preferredFrom.split(":")[0]),
          parseInt(this.pickup.preferredTo.split(":")[1])
        );
      }
      this.pickupPreferredRangeTime = [dff, dtt];
    }
  }

  // sets the date ranges
  /*
   *ups shows only 1 hour type (preferred)																	idCourier:1
   *tnt shows 2 hour types (preferred / alternative)															idCourier:3
   *nexive (morning / afternoon) -> shows a radio input that automatically select the right time range		idCourier:7
   */
  fillDateRanges() {
    // Nexive radio
    if (this.shipment.courierId === this.courierNexiveId) {
      const df = new Date();
      const dt = new Date();
      // morning: range 9-12
      if (this.preferredTimeNexive === "morning") {
        df.setHours(9);
        dt.setHours(12);
        // afternoon: range 13-18
      } else {
        df.setHours(13);
        dt.setHours(18);
      }
      this.pickup.preferredFrom = format(df, "HH:mm");
      this.pickup.preferredTo = format(dt, "HH:mm");
    } else {
      this.pickup.preferredFrom = format(
        this.pickupPreferredRangeTime[0],
        "HH:mm"
      );
      this.pickup.preferredTo = format(
        this.pickupPreferredRangeTime[1],
        "HH:mm"
      );
      // if TNT|SDA use 2 dates
      if (this.showAlternativeRange) {
        this.pickup.alternativeFrom = format(
          this.pickupAlternativeRangeTime[0],
          "HH:mm"
        );
        this.pickup.alternativeTo = format(
          this.pickupAlternativeRangeTime[1],
          "HH:mm"
        );
      } else {
        this.pickup.alternativeFrom = null;
        this.pickup.alternativeTo = null;
      }
    }

    this.pickup.pickupDate = format(this.pickup.pickupDate, "yyyy-MM-dd");

    // fix: creationDate if string timestamp value as long timestmp
    if (
      this.pickup.creationDate &&
      typeof this.pickup.creationDate === "string" &&
      this.pickup.creationDate.indexOf("T") != -1
    ) {
      this.pickup.creationDate = new Date(this.pickup.creationDate).getTime();
    }

    // init if null
    if (this.pickup.creationDate === "" || !this.pickup.creationDate) {
      this.pickup.creationDate = new Date().getTime();
    }
  }

  get showAlternativeRange() {
    if (isItaly()) {
      return (
        this.shipment.courierId === this.courierTntId ||
        this.shipment.courierId === this.courierSDAId
      );
    } else {
      return this.shipment.courierId === this.courierSDAId;
    }
  }

  get isDeliveryPoint() {
    return (
      this.shipment.mbeServiceId ===
        MBEShipServiceBusiness.GEL_PROXIMITY_POINT ||
      this.shipment.mbeServiceId === MBEShipServiceBusiness.MBE_ACCESS_POINT
    );
  }
}
